module.exports = __webpack_public_path__ + "static/media/sparkle-up.dfe131c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/sparkle-up.svg
// module id = 749
// module chunks = 50